import { combineActions, handleActions } from 'redux-actions';
import {
  HomePageDataResponse,
  PageId,
  PagesReducerPayload,
  PagesState,
  RootState,
  SafelockPageDataResponse,
  SettingsPageDataResponse
} from '../../../types';
import pagesActions from './actions';

export default handleActions<PagesState<PageId>, PagesReducerPayload>(
  {
    [combineActions(
      pagesActions.fetchHomePageSuccess,
      pagesActions.fetchUserPageSuccess,
      pagesActions.fetchPageSuccess
    ).toString()]: (state, action) => {
      const { pageId, pageData } = action.payload;
      return {
        ...state,
        [pageId]: pageData
      };
    }
  },
  {}
);

export const getPageInfo = <Selected = unknown>(pageId: PageId) => (
  state: RootState
): Selected => state.app.pages[pageId];
export const getHomePageInfo = getPageInfo<HomePageDataResponse>('home');
export const getSettingsPageInfo = getPageInfo<SettingsPageDataResponse>(
  'settings'
);
export const getSafelockPageInfo = getPageInfo<SafelockPageDataResponse>(
  'safelocks'
);
export const getUser = (state: RootState) => {
  const home = getHomePageInfo(state);
  if (!home) {
    return null;
  }
  return home.userdata;
};
